module.exports = __webpack_public_path__ + "static/media/favicon.11c77665.ico";